<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Wysyłanie wyceny do kontrahenta' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">
        <p class="document-code">{{'SALES_DOCUMENT|Nr zapytania ofertowego:' | translate}} <b>{{data.document.documentNumber.join('')}}</b></p>

        <div class="valuation-options">

            <icc-form-field
                size="small"
            >
                <label iccLabel>{{ 'SALES_DOCUMENT|Termin ważności wyceny' | translate }}</label>
                <icc-input
                    type="date"
                    [value]="validityDate"
                    (valueChange)="validityDate = $event"
                >
                </icc-input>

            </icc-form-field>
        </div>

        <p *ngIf="data.hasNonValuatedPositions">{{ 'SALES_DOCUMENT|Nie wszystkie pozycje zostały wycenione, czy mimo to przekazać wycenę do kontrahenta?' | translate}}</p>
        <p *ngIf="!data.hasNonValuatedPositions">{{ 'SALES_DOCUMENT|Czy przekazać wycenę do kontrahenta?' | translate}}</p>
    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button iccButton (click)="close()">{{ 'INTERFACE|Anuluj' | translate}}</button>
            <button iccButton (click)="send()">{{ 'SALES_DOCUMENT|Wyślij wycenę' | translate}}</button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
